module.exports = __webpack_public_path__ + "static/img/scene__sun.6eb60e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/scene__sun.svg
// module id = 41
// module chunks = 0